import React from 'react'
import HoverableSpotlight from 'src/components/HoverableSpotlight/HoverableSpotlight'
import SvgDeactivatedUserAvatar from 'src/components/Svgs/SvgDeactivatedUserAvatar'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

const DeactivatedUserIndicator: React.FC = (): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        margin-left: 4px;
      `}
    >
      <HoverableSpotlight
        tooltipWidth={20}
        tooltipCenter
        iconSrc={
          <span
            css={css`
              display: flex;
              padding: 3px;
              height: 20px;
              width: 20px;
            `}
          >
            <SvgDeactivatedUserAvatar
              css={css`
                transform: scale(calc(13.69 / 30));
                transform-origin: top left;
                overflow: visible;
              `}
            />
          </span>
        }
      >
        {translate('This user has been deactivated')}
      </HoverableSpotlight>
    </div>
  )
}

export default DeactivatedUserIndicator
